import { DevtoolsNotFound } from '@/components/devtools/Devtools';
import ErrorTemplate from '@/components/layouts/ErrorTemplate';
import { PRODUCT } from '@/consts';
import DevtoolsCaseCard from '@/features/caseCard/Devtools';
import NotFoundProduct from '@/routes/errors/NotFound';
import SomethingWentWrong, {
  SomethingWentWrongVariants,
} from '@/routes/errors/SomethingWentWrong';

import { useLingui } from '@lingui/react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

const ContextBoundary = ({ pit = false }: { pit?: boolean }) => {
  const error = useRouteError();

  const { i18n } = useLingui();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <NotFoundProduct message={error.data} />;
    }

    if (error.status === 401) {
      return (
        <SomethingWentWrong
          code={401}
          variant={SomethingWentWrongVariants.Comeback}
          message={error?.statusText?.toString()}
          productId={pit ? PRODUCT.PIT : undefined}
        />
      );
    }

    if (error.status === 503) {
      return (
        <SomethingWentWrong
          code={500}
          variant={SomethingWentWrongVariants.Comeback}
          message={error?.statusText?.toString()}
          productId={pit ? PRODUCT.PIT : undefined}
        />
      );
    }

    if (error.status === 429) {
      return (
        <ErrorTemplate
          code={429}
          message={i18n.t(
            `Jesteś za szybki dla serwera, sprób ponownie później`
          )}
        />
      );
    }

    if (error.status === 418) {
      return <ErrorTemplate code={418} message={'🫖'} />;
    }
  }

  return (
    <SomethingWentWrong code={'Upsss'} message={(error as string).toString()} />
  );
};

const showDevtools = import.meta.env.VITE_SHOW_DEV_TOOLS === 'true';

const RootBoundary = ({
  caseCard = false,
  pit = false,
}: {
  caseCard?: boolean;
  pit?: boolean;
}) => {
  if (caseCard) {
    return (
      <div>
        <ContextBoundary />
        {showDevtools && <DevtoolsCaseCard />}
      </div>
    );
  }
  if (pit) {
    return (
      <div>
        <ContextBoundary pit />
      </div>
    );
  }
  return (
    <div>
      <ContextBoundary />
      {showDevtools && <DevtoolsNotFound />}
    </div>
  );
};

export default RootBoundary;
